import { formatarData, formatarMoeda } from "../../../utils/solicitacoes/formatters";
import Campo from "../Shared/Campo";

// Dados acumulados do processo — sempre visível, independentemente da etapa atual. Cada seção só
// aparece quando a etapa correspondente já foi preenchida.
export default function DetalheMulta({ detalheProcesso }) {
    if (!detalheProcesso) return null;

    return (
        <div className="bg-card border border-border rounded-lg shadow-card p-4 md:p-6 flex flex-col gap-4">
            <div>
                <h2 className="font-display text-base font-semibold text-foreground mb-4">Dados da Infração</h2>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <Campo label="Unidade" valor={detalheProcesso.unidadeNome} />
                    <Campo label="Veículo" valor={detalheProcesso.veiculoId ? `${detalheProcesso.veiculoPlaca}${detalheProcesso.veiculoCodigoYork ? ` · ${detalheProcesso.veiculoCodigoYork}` : ""}` : null} />
                    <Campo label="RENAINF" valor={detalheProcesso.renainf} />
                    <Campo label="Natureza" valor={detalheProcesso.natureza} />
                    <Campo label="Data da infração" valor={formatarData(detalheProcesso.dataInfracao)} />
                    <Campo label="Hora" valor={detalheProcesso.horaInfracao} />
                    <Campo label="Local" valor={detalheProcesso.local} />
                    <Campo label="Data da notificação" valor={formatarData(detalheProcesso.dataNotificacao)} />
                    <Campo label="Descrição" valor={detalheProcesso.descricao} />
                </div>
            </div>

            <div>
                <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Dados Financeiros</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <Campo label="Valor da multa" valor={formatarMoeda(detalheProcesso.valorMulta)} />
                    <Campo label="Valor do boleto" valor={formatarMoeda(detalheProcesso.valorBoleto)} />
                    <Campo label="Data de vencimento" valor={formatarData(detalheProcesso.dataVencimento)} />
                    <Campo label="Valor descontado" valor={formatarMoeda(detalheProcesso.valorDescontado)} />
                    <Campo label="Parcelamento" valor={detalheProcesso.parcelamento} />
                </div>
            </div>

            {detalheProcesso.condutorId && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Responsável</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                        <Campo label="Condutor" valor={detalheProcesso.condutorNome} />
                        <Campo label="CPF" valor={detalheProcesso.condutorCpf} />
                        <Campo label="CNH" valor={detalheProcesso.condutorCnh} />
                    </div>
                </div>
            )}

            {detalheProcesso.valorPago != null && (
                <div>
                    <h3 className="text-[11px] uppercase tracking-wide font-semibold text-muted-foreground mb-2">Pagamento</h3>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                        <Campo label="Valor pago" valor={formatarMoeda(detalheProcesso.valorPago)} />
                        <Campo label="Data do pagamento" valor={formatarData(detalheProcesso.dataPagamento)} />
                        <Campo label="Forma de pagamento" valor={detalheProcesso.formaPagamento} />
                        <Campo label="Número do comprovante" valor={detalheProcesso.numeroComprovante} />
                    </div>
                </div>
            )}
        </div>
    );
}
